var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("job-publish-section-title", { attrs: { title: _vm.title } }),
      _vm._v(" "),
      _c("table", { staticClass: "unstriped hover boss-table" }, [
        _c("thead", [_vm._t("head")], 2),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.renderingObjects, function (object, i) {
              return [
                _c(_vm.componentName, {
                  key: i,
                  tag: "component",
                  attrs: {
                    job: object,
                    option: object,
                    "is-publishing": false,
                  },
                }),
              ]
            }),
            _vm._v(" "),
            !_vm.isClosed
              ? _c(
                  "infinite-loading",
                  { on: { infinite: _vm.infiniteHandler } },
                  [
                    _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
                    _vm._v(" "),
                    _c("div", {
                      attrs: { slot: "no-results" },
                      slot: "no-results",
                    }),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.isExistsMoreObjects
        ? _c(
            "div",
            {
              staticClass: "text-center",
              class: { "pega-past-more-close-button": !_vm.isClosed },
              attrs: { "data-test": "button" },
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "boss-button-center boss-button-large margin-top-1 margin-bottom-1",
                  attrs: { "data-test": "more-close-button" },
                  on: {
                    click: function ($event) {
                      _vm.isClosed = !_vm.isClosed
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.isClosed ? "もっと見る" : "閉じる") +
                      "\n    "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }